// reducers/employeeSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showSuccess } from "../../helpers/toast";
import { attachApiErrorToast } from "../../helpers/apiNotify";
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});
attachApiErrorToast(API, { fallback: "Password reset request failed" });

const initialState = {
  password: null,
  new_password: null,
  passwordresetcode: null,
  loading: false,
  message: null,
  error: null,
};

export const resetPassword = createAsyncThunk(
  "resetPassword/",
  async (data) => {
    try {
      const config = {
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
      };
      const response = await API.post("/users/reset-password", data, config);
      showSuccess("You password has been reset!");
      return response.data;
    } catch (error) {
      throw new Error(error?.response?.data?.error || "Failed to signup");
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        // state.message = action.payload.message;
      });
  },
});

export default resetPasswordSlice.reducer;
